import React, { useEffect, useRef } from "react";
import styles from "./PopupCard.module.css";

interface PopupCardProps {
    children: React.ReactNode;
    visible: boolean;
    onClose: () => void;
}

const PopupCard: React.FC<PopupCardProps> = ({ children, visible, onClose }) => {
    const cardRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (onClose && cardRef.current && !cardRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (visible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.card} ref={cardRef}>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default PopupCard;
